/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.beatgen.Equalizer', null, global)
goog.exportSymbol('proto.beatgen.InstrumentFlow', null, global)
goog.exportSymbol('proto.beatgen.InstrumentFlow.Part', null, global)
goog.exportSymbol('proto.beatgen.InstrumentGain', null, global)
goog.exportSymbol('proto.beatgen.InstrumentPart', null, global)
goog.exportSymbol('proto.beatgen.Key', null, global)
goog.exportSymbol('proto.beatgen.MasterCompressor', null, global)
goog.exportSymbol('proto.beatgen.Octave', null, global)
goog.exportSymbol('proto.beatgen.SampleType', null, global)
goog.exportSymbol('proto.beatgen.SelectedSamples', null, global)
goog.exportSymbol('proto.beatgen.SongInternal', null, global)
goog.exportSymbol('proto.beatgen.SongStructure', null, global)
goog.exportSymbol('proto.beatgen.Sound', null, global)

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.SongInternal = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.SongInternal, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.SongInternal.displayName = 'proto.beatgen.SongInternal'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.SongInternal.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.SongInternal.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.SongInternal} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.SongInternal.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        key: jspb.Message.getField(msg, 1),
        tempo: jspb.Message.getField(msg, 3),
        selectedSamples:
          (f = msg.getSelectedSamples()) &&
          proto.beatgen.SelectedSamples.toObject(includeInstance, f),
        songStructure:
          (f = msg.getSongStructure()) && proto.beatgen.SongStructure.toObject(includeInstance, f),
        hatA: (f = msg.getHatA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        hatB: (f = msg.getHatB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        hatC: (f = msg.getHatC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        percA: (f = msg.getPercA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        percB: (f = msg.getPercB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        percC: (f = msg.getPercC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        snareA: (f = msg.getSnareA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        snareB: (f = msg.getSnareB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        snareC: (f = msg.getSnareC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        kickA: (f = msg.getKickA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        kickB: (f = msg.getKickB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        kickC: (f = msg.getKickC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        bassA: (f = msg.getBassA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        bassB: (f = msg.getBassB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        bassC: (f = msg.getBassC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        melodyA:
          (f = msg.getMelodyA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        melodyB:
          (f = msg.getMelodyB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        melodyC:
          (f = msg.getMelodyC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        harmonyA:
          (f = msg.getHarmonyA()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        harmonyB:
          (f = msg.getHarmonyB()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        harmonyC:
          (f = msg.getHarmonyC()) && proto.beatgen.InstrumentPart.toObject(includeInstance, f),
        melodyOctave: jspb.Message.getField(msg, 28),
        harmonyOctave: jspb.Message.getField(msg, 29),
        bassOctave: jspb.Message.getField(msg, 30),
        instrumentGain:
          (f = msg.getInstrumentGain()) &&
          proto.beatgen.InstrumentGain.toObject(includeInstance, f),
        compressor:
          (f = msg.getCompressor()) && proto.beatgen.MasterCompressor.toObject(includeInstance, f),
        equalizer: (f = msg.getEqualizer()) && proto.beatgen.Equalizer.toObject(includeInstance, f),
        minor: jspb.Message.getField(msg, 2)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.SongInternal}
 */
proto.beatgen.SongInternal.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.SongInternal()
  return proto.beatgen.SongInternal.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.SongInternal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.SongInternal}
 */
proto.beatgen.SongInternal.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {!proto.beatgen.Key} */ (reader.readEnum())
        msg.setKey(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setTempo(value)
        break
      case 4:
        var value = new proto.beatgen.SelectedSamples()
        reader.readMessage(value, proto.beatgen.SelectedSamples.deserializeBinaryFromReader)
        msg.setSelectedSamples(value)
        break
      case 5:
        var value = new proto.beatgen.SongStructure()
        reader.readMessage(value, proto.beatgen.SongStructure.deserializeBinaryFromReader)
        msg.setSongStructure(value)
        break
      case 6:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setHatA(value)
        break
      case 7:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setHatB(value)
        break
      case 21:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setHatC(value)
        break
      case 18:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setPercA(value)
        break
      case 19:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setPercB(value)
        break
      case 20:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setPercC(value)
        break
      case 8:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setSnareA(value)
        break
      case 9:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setSnareB(value)
        break
      case 22:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setSnareC(value)
        break
      case 10:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setKickA(value)
        break
      case 11:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setKickB(value)
        break
      case 23:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setKickC(value)
        break
      case 12:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setBassA(value)
        break
      case 13:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setBassB(value)
        break
      case 24:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setBassC(value)
        break
      case 14:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setMelodyA(value)
        break
      case 15:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setMelodyB(value)
        break
      case 25:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setMelodyC(value)
        break
      case 16:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setHarmonyA(value)
        break
      case 17:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setHarmonyB(value)
        break
      case 27:
        var value = new proto.beatgen.InstrumentPart()
        reader.readMessage(value, proto.beatgen.InstrumentPart.deserializeBinaryFromReader)
        msg.setHarmonyC(value)
        break
      case 28:
        var value = /** @type {!proto.beatgen.Octave} */ (reader.readEnum())
        msg.setMelodyOctave(value)
        break
      case 29:
        var value = /** @type {!proto.beatgen.Octave} */ (reader.readEnum())
        msg.setHarmonyOctave(value)
        break
      case 30:
        var value = /** @type {!proto.beatgen.Octave} */ (reader.readEnum())
        msg.setBassOctave(value)
        break
      case 31:
        var value = new proto.beatgen.InstrumentGain()
        reader.readMessage(value, proto.beatgen.InstrumentGain.deserializeBinaryFromReader)
        msg.setInstrumentGain(value)
        break
      case 32:
        var value = new proto.beatgen.MasterCompressor()
        reader.readMessage(value, proto.beatgen.MasterCompressor.deserializeBinaryFromReader)
        msg.setCompressor(value)
        break
      case 33:
        var value = new proto.beatgen.Equalizer()
        reader.readMessage(value, proto.beatgen.Equalizer.deserializeBinaryFromReader)
        msg.setEqualizer(value)
        break
      case 2:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setMinor(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.SongInternal.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.SongInternal.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.SongInternal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.SongInternal.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = /** @type {!proto.beatgen.Key} */ (jspb.Message.getField(message, 1))
  if (f !== null) {
    writer.writeEnum(1, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3))
  if (f !== null) {
    writer.writeInt32(3, f)
  }
  f = message.getSelectedSamples()
  if (f !== null) {
    writer.writeMessage(4, f, proto.beatgen.SelectedSamples.serializeBinaryToWriter)
  }
  f = message.getSongStructure()
  if (f !== null) {
    writer.writeMessage(5, f, proto.beatgen.SongStructure.serializeBinaryToWriter)
  }
  f = message.getHatA()
  if (f !== null) {
    writer.writeMessage(6, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getHatB()
  if (f !== null) {
    writer.writeMessage(7, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getHatC()
  if (f !== null) {
    writer.writeMessage(21, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getPercA()
  if (f !== null) {
    writer.writeMessage(18, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getPercB()
  if (f !== null) {
    writer.writeMessage(19, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getPercC()
  if (f !== null) {
    writer.writeMessage(20, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getSnareA()
  if (f !== null) {
    writer.writeMessage(8, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getSnareB()
  if (f !== null) {
    writer.writeMessage(9, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getSnareC()
  if (f !== null) {
    writer.writeMessage(22, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getKickA()
  if (f !== null) {
    writer.writeMessage(10, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getKickB()
  if (f !== null) {
    writer.writeMessage(11, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getKickC()
  if (f !== null) {
    writer.writeMessage(23, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getBassA()
  if (f !== null) {
    writer.writeMessage(12, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getBassB()
  if (f !== null) {
    writer.writeMessage(13, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getBassC()
  if (f !== null) {
    writer.writeMessage(24, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getMelodyA()
  if (f !== null) {
    writer.writeMessage(14, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getMelodyB()
  if (f !== null) {
    writer.writeMessage(15, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getMelodyC()
  if (f !== null) {
    writer.writeMessage(25, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getHarmonyA()
  if (f !== null) {
    writer.writeMessage(16, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getHarmonyB()
  if (f !== null) {
    writer.writeMessage(17, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = message.getHarmonyC()
  if (f !== null) {
    writer.writeMessage(27, f, proto.beatgen.InstrumentPart.serializeBinaryToWriter)
  }
  f = /** @type {!proto.beatgen.Octave} */ (jspb.Message.getField(message, 28))
  if (f !== null) {
    writer.writeEnum(28, f)
  }
  f = /** @type {!proto.beatgen.Octave} */ (jspb.Message.getField(message, 29))
  if (f !== null) {
    writer.writeEnum(29, f)
  }
  f = /** @type {!proto.beatgen.Octave} */ (jspb.Message.getField(message, 30))
  if (f !== null) {
    writer.writeEnum(30, f)
  }
  f = message.getInstrumentGain()
  if (f !== null) {
    writer.writeMessage(31, f, proto.beatgen.InstrumentGain.serializeBinaryToWriter)
  }
  f = message.getCompressor()
  if (f !== null) {
    writer.writeMessage(32, f, proto.beatgen.MasterCompressor.serializeBinaryToWriter)
  }
  f = message.getEqualizer()
  if (f !== null) {
    writer.writeMessage(33, f, proto.beatgen.Equalizer.serializeBinaryToWriter)
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2))
  if (f !== null) {
    writer.writeBool(2, f)
  }
}

/**
 * optional Key key = 1;
 * @return {!proto.beatgen.Key}
 */
proto.beatgen.SongInternal.prototype.getKey = function () {
  return /** @type {!proto.beatgen.Key} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/** @param {!proto.beatgen.Key} value */
proto.beatgen.SongInternal.prototype.setKey = function (value) {
  jspb.Message.setField(this, 1, value)
}

proto.beatgen.SongInternal.prototype.clearKey = function () {
  jspb.Message.setField(this, 1, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasKey = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional int32 tempo = 3;
 * @return {number}
 */
proto.beatgen.SongInternal.prototype.getTempo = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/** @param {number} value */
proto.beatgen.SongInternal.prototype.setTempo = function (value) {
  jspb.Message.setField(this, 3, value)
}

proto.beatgen.SongInternal.prototype.clearTempo = function () {
  jspb.Message.setField(this, 3, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasTempo = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * optional SelectedSamples selected_samples = 4;
 * @return {?proto.beatgen.SelectedSamples}
 */
proto.beatgen.SongInternal.prototype.getSelectedSamples = function () {
  return /** @type{?proto.beatgen.SelectedSamples} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.SelectedSamples, 4)
  )
}

/** @param {?proto.beatgen.SelectedSamples|undefined} value */
proto.beatgen.SongInternal.prototype.setSelectedSamples = function (value) {
  jspb.Message.setWrapperField(this, 4, value)
}

proto.beatgen.SongInternal.prototype.clearSelectedSamples = function () {
  this.setSelectedSamples(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasSelectedSamples = function () {
  return jspb.Message.getField(this, 4) !== null
}

/**
 * optional SongStructure song_structure = 5;
 * @return {?proto.beatgen.SongStructure}
 */
proto.beatgen.SongInternal.prototype.getSongStructure = function () {
  return /** @type{?proto.beatgen.SongStructure} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.SongStructure, 5)
  )
}

/** @param {?proto.beatgen.SongStructure|undefined} value */
proto.beatgen.SongInternal.prototype.setSongStructure = function (value) {
  jspb.Message.setWrapperField(this, 5, value)
}

proto.beatgen.SongInternal.prototype.clearSongStructure = function () {
  this.setSongStructure(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasSongStructure = function () {
  return jspb.Message.getField(this, 5) !== null
}

/**
 * optional InstrumentPart hat_a = 6;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getHatA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 6)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setHatA = function (value) {
  jspb.Message.setWrapperField(this, 6, value)
}

proto.beatgen.SongInternal.prototype.clearHatA = function () {
  this.setHatA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHatA = function () {
  return jspb.Message.getField(this, 6) !== null
}

/**
 * optional InstrumentPart hat_b = 7;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getHatB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 7)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setHatB = function (value) {
  jspb.Message.setWrapperField(this, 7, value)
}

proto.beatgen.SongInternal.prototype.clearHatB = function () {
  this.setHatB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHatB = function () {
  return jspb.Message.getField(this, 7) !== null
}

/**
 * optional InstrumentPart hat_c = 21;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getHatC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 21)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setHatC = function (value) {
  jspb.Message.setWrapperField(this, 21, value)
}

proto.beatgen.SongInternal.prototype.clearHatC = function () {
  this.setHatC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHatC = function () {
  return jspb.Message.getField(this, 21) !== null
}

/**
 * optional InstrumentPart perc_a = 18;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getPercA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 18)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setPercA = function (value) {
  jspb.Message.setWrapperField(this, 18, value)
}

proto.beatgen.SongInternal.prototype.clearPercA = function () {
  this.setPercA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasPercA = function () {
  return jspb.Message.getField(this, 18) !== null
}

/**
 * optional InstrumentPart perc_b = 19;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getPercB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 19)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setPercB = function (value) {
  jspb.Message.setWrapperField(this, 19, value)
}

proto.beatgen.SongInternal.prototype.clearPercB = function () {
  this.setPercB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasPercB = function () {
  return jspb.Message.getField(this, 19) !== null
}

/**
 * optional InstrumentPart perc_c = 20;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getPercC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 20)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setPercC = function (value) {
  jspb.Message.setWrapperField(this, 20, value)
}

proto.beatgen.SongInternal.prototype.clearPercC = function () {
  this.setPercC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasPercC = function () {
  return jspb.Message.getField(this, 20) !== null
}

/**
 * optional InstrumentPart snare_a = 8;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getSnareA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 8)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setSnareA = function (value) {
  jspb.Message.setWrapperField(this, 8, value)
}

proto.beatgen.SongInternal.prototype.clearSnareA = function () {
  this.setSnareA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasSnareA = function () {
  return jspb.Message.getField(this, 8) !== null
}

/**
 * optional InstrumentPart snare_b = 9;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getSnareB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 9)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setSnareB = function (value) {
  jspb.Message.setWrapperField(this, 9, value)
}

proto.beatgen.SongInternal.prototype.clearSnareB = function () {
  this.setSnareB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasSnareB = function () {
  return jspb.Message.getField(this, 9) !== null
}

/**
 * optional InstrumentPart snare_c = 22;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getSnareC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 22)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setSnareC = function (value) {
  jspb.Message.setWrapperField(this, 22, value)
}

proto.beatgen.SongInternal.prototype.clearSnareC = function () {
  this.setSnareC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasSnareC = function () {
  return jspb.Message.getField(this, 22) !== null
}

/**
 * optional InstrumentPart kick_a = 10;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getKickA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 10)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setKickA = function (value) {
  jspb.Message.setWrapperField(this, 10, value)
}

proto.beatgen.SongInternal.prototype.clearKickA = function () {
  this.setKickA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasKickA = function () {
  return jspb.Message.getField(this, 10) !== null
}

/**
 * optional InstrumentPart kick_b = 11;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getKickB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 11)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setKickB = function (value) {
  jspb.Message.setWrapperField(this, 11, value)
}

proto.beatgen.SongInternal.prototype.clearKickB = function () {
  this.setKickB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasKickB = function () {
  return jspb.Message.getField(this, 11) !== null
}

/**
 * optional InstrumentPart kick_c = 23;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getKickC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 23)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setKickC = function (value) {
  jspb.Message.setWrapperField(this, 23, value)
}

proto.beatgen.SongInternal.prototype.clearKickC = function () {
  this.setKickC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasKickC = function () {
  return jspb.Message.getField(this, 23) !== null
}

/**
 * optional InstrumentPart bass_a = 12;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getBassA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 12)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setBassA = function (value) {
  jspb.Message.setWrapperField(this, 12, value)
}

proto.beatgen.SongInternal.prototype.clearBassA = function () {
  this.setBassA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasBassA = function () {
  return jspb.Message.getField(this, 12) !== null
}

/**
 * optional InstrumentPart bass_b = 13;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getBassB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 13)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setBassB = function (value) {
  jspb.Message.setWrapperField(this, 13, value)
}

proto.beatgen.SongInternal.prototype.clearBassB = function () {
  this.setBassB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasBassB = function () {
  return jspb.Message.getField(this, 13) !== null
}

/**
 * optional InstrumentPart bass_c = 24;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getBassC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 24)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setBassC = function (value) {
  jspb.Message.setWrapperField(this, 24, value)
}

proto.beatgen.SongInternal.prototype.clearBassC = function () {
  this.setBassC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasBassC = function () {
  return jspb.Message.getField(this, 24) !== null
}

/**
 * optional InstrumentPart melody_a = 14;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getMelodyA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 14)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setMelodyA = function (value) {
  jspb.Message.setWrapperField(this, 14, value)
}

proto.beatgen.SongInternal.prototype.clearMelodyA = function () {
  this.setMelodyA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasMelodyA = function () {
  return jspb.Message.getField(this, 14) !== null
}

/**
 * optional InstrumentPart melody_b = 15;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getMelodyB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 15)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setMelodyB = function (value) {
  jspb.Message.setWrapperField(this, 15, value)
}

proto.beatgen.SongInternal.prototype.clearMelodyB = function () {
  this.setMelodyB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasMelodyB = function () {
  return jspb.Message.getField(this, 15) !== null
}

/**
 * optional InstrumentPart melody_c = 25;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getMelodyC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 25)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setMelodyC = function (value) {
  jspb.Message.setWrapperField(this, 25, value)
}

proto.beatgen.SongInternal.prototype.clearMelodyC = function () {
  this.setMelodyC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasMelodyC = function () {
  return jspb.Message.getField(this, 25) !== null
}

/**
 * optional InstrumentPart harmony_a = 16;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getHarmonyA = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 16)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setHarmonyA = function (value) {
  jspb.Message.setWrapperField(this, 16, value)
}

proto.beatgen.SongInternal.prototype.clearHarmonyA = function () {
  this.setHarmonyA(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHarmonyA = function () {
  return jspb.Message.getField(this, 16) !== null
}

/**
 * optional InstrumentPart harmony_b = 17;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getHarmonyB = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 17)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setHarmonyB = function (value) {
  jspb.Message.setWrapperField(this, 17, value)
}

proto.beatgen.SongInternal.prototype.clearHarmonyB = function () {
  this.setHarmonyB(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHarmonyB = function () {
  return jspb.Message.getField(this, 17) !== null
}

/**
 * optional InstrumentPart harmony_c = 27;
 * @return {?proto.beatgen.InstrumentPart}
 */
proto.beatgen.SongInternal.prototype.getHarmonyC = function () {
  return /** @type{?proto.beatgen.InstrumentPart} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentPart, 27)
  )
}

/** @param {?proto.beatgen.InstrumentPart|undefined} value */
proto.beatgen.SongInternal.prototype.setHarmonyC = function (value) {
  jspb.Message.setWrapperField(this, 27, value)
}

proto.beatgen.SongInternal.prototype.clearHarmonyC = function () {
  this.setHarmonyC(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHarmonyC = function () {
  return jspb.Message.getField(this, 27) !== null
}

/**
 * optional Octave melody_octave = 28;
 * @return {!proto.beatgen.Octave}
 */
proto.beatgen.SongInternal.prototype.getMelodyOctave = function () {
  return /** @type {!proto.beatgen.Octave} */ (jspb.Message.getFieldWithDefault(this, 28, 0))
}

/** @param {!proto.beatgen.Octave} value */
proto.beatgen.SongInternal.prototype.setMelodyOctave = function (value) {
  jspb.Message.setField(this, 28, value)
}

proto.beatgen.SongInternal.prototype.clearMelodyOctave = function () {
  jspb.Message.setField(this, 28, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasMelodyOctave = function () {
  return jspb.Message.getField(this, 28) !== null
}

/**
 * optional Octave harmony_octave = 29;
 * @return {!proto.beatgen.Octave}
 */
proto.beatgen.SongInternal.prototype.getHarmonyOctave = function () {
  return /** @type {!proto.beatgen.Octave} */ (jspb.Message.getFieldWithDefault(this, 29, 0))
}

/** @param {!proto.beatgen.Octave} value */
proto.beatgen.SongInternal.prototype.setHarmonyOctave = function (value) {
  jspb.Message.setField(this, 29, value)
}

proto.beatgen.SongInternal.prototype.clearHarmonyOctave = function () {
  jspb.Message.setField(this, 29, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasHarmonyOctave = function () {
  return jspb.Message.getField(this, 29) !== null
}

/**
 * optional Octave bass_octave = 30;
 * @return {!proto.beatgen.Octave}
 */
proto.beatgen.SongInternal.prototype.getBassOctave = function () {
  return /** @type {!proto.beatgen.Octave} */ (jspb.Message.getFieldWithDefault(this, 30, 0))
}

/** @param {!proto.beatgen.Octave} value */
proto.beatgen.SongInternal.prototype.setBassOctave = function (value) {
  jspb.Message.setField(this, 30, value)
}

proto.beatgen.SongInternal.prototype.clearBassOctave = function () {
  jspb.Message.setField(this, 30, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasBassOctave = function () {
  return jspb.Message.getField(this, 30) !== null
}

/**
 * optional InstrumentGain instrument_gain = 31;
 * @return {?proto.beatgen.InstrumentGain}
 */
proto.beatgen.SongInternal.prototype.getInstrumentGain = function () {
  return /** @type{?proto.beatgen.InstrumentGain} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentGain, 31)
  )
}

/** @param {?proto.beatgen.InstrumentGain|undefined} value */
proto.beatgen.SongInternal.prototype.setInstrumentGain = function (value) {
  jspb.Message.setWrapperField(this, 31, value)
}

proto.beatgen.SongInternal.prototype.clearInstrumentGain = function () {
  this.setInstrumentGain(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasInstrumentGain = function () {
  return jspb.Message.getField(this, 31) !== null
}

/**
 * optional MasterCompressor compressor = 32;
 * @return {?proto.beatgen.MasterCompressor}
 */
proto.beatgen.SongInternal.prototype.getCompressor = function () {
  return /** @type{?proto.beatgen.MasterCompressor} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.MasterCompressor, 32)
  )
}

/** @param {?proto.beatgen.MasterCompressor|undefined} value */
proto.beatgen.SongInternal.prototype.setCompressor = function (value) {
  jspb.Message.setWrapperField(this, 32, value)
}

proto.beatgen.SongInternal.prototype.clearCompressor = function () {
  this.setCompressor(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasCompressor = function () {
  return jspb.Message.getField(this, 32) !== null
}

/**
 * optional Equalizer equalizer = 33;
 * @return {?proto.beatgen.Equalizer}
 */
proto.beatgen.SongInternal.prototype.getEqualizer = function () {
  return /** @type{?proto.beatgen.Equalizer} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.Equalizer, 33)
  )
}

/** @param {?proto.beatgen.Equalizer|undefined} value */
proto.beatgen.SongInternal.prototype.setEqualizer = function (value) {
  jspb.Message.setWrapperField(this, 33, value)
}

proto.beatgen.SongInternal.prototype.clearEqualizer = function () {
  this.setEqualizer(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasEqualizer = function () {
  return jspb.Message.getField(this, 33) !== null
}

/**
 * optional bool minor = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.beatgen.SongInternal.prototype.getMinor = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false))
}

/** @param {boolean} value */
proto.beatgen.SongInternal.prototype.setMinor = function (value) {
  jspb.Message.setField(this, 2, value)
}

proto.beatgen.SongInternal.prototype.clearMinor = function () {
  jspb.Message.setField(this, 2, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongInternal.prototype.hasMinor = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.InstrumentPart = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.beatgen.InstrumentPart.repeatedFields_, null)
}
goog.inherits(proto.beatgen.InstrumentPart, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.InstrumentPart.displayName = 'proto.beatgen.InstrumentPart'
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.beatgen.InstrumentPart.repeatedFields_ = [1]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.InstrumentPart.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.InstrumentPart.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.InstrumentPart} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.InstrumentPart.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        notesList: jspb.Message.getRepeatedField(msg, 1)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.InstrumentPart}
 */
proto.beatgen.InstrumentPart.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.InstrumentPart()
  return proto.beatgen.InstrumentPart.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.InstrumentPart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.InstrumentPart}
 */
proto.beatgen.InstrumentPart.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readUint32())
        msg.addNotes(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.InstrumentPart.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.InstrumentPart.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.InstrumentPart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.InstrumentPart.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getNotesList()
  if (f.length > 0) {
    writer.writeRepeatedUint32(1, f)
  }
}

/**
 * repeated uint32 notes = 1;
 * @return {!Array.<number>}
 */
proto.beatgen.InstrumentPart.prototype.getNotesList = function () {
  return /** @type {!Array.<number>} */ (jspb.Message.getRepeatedField(this, 1))
}

/** @param {!Array.<number>} value */
proto.beatgen.InstrumentPart.prototype.setNotesList = function (value) {
  jspb.Message.setField(this, 1, value || [])
}

/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.beatgen.InstrumentPart.prototype.addNotes = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index)
}

proto.beatgen.InstrumentPart.prototype.clearNotesList = function () {
  this.setNotesList([])
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.SongStructure = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.SongStructure, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.SongStructure.displayName = 'proto.beatgen.SongStructure'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.SongStructure.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.SongStructure.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.SongStructure} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.SongStructure.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        hatFlow:
          (f = msg.getHatFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        percFlow:
          (f = msg.getPercFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        snareFlow:
          (f = msg.getSnareFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        kickFlow:
          (f = msg.getKickFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        bassFlow:
          (f = msg.getBassFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        melodyFlow:
          (f = msg.getMelodyFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        harmonyFlow:
          (f = msg.getHarmonyFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f),
        specialFlow:
          (f = msg.getSpecialFlow()) && proto.beatgen.InstrumentFlow.toObject(includeInstance, f)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.SongStructure}
 */
proto.beatgen.SongStructure.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.SongStructure()
  return proto.beatgen.SongStructure.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.SongStructure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.SongStructure}
 */
proto.beatgen.SongStructure.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setHatFlow(value)
        break
      case 7:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setPercFlow(value)
        break
      case 2:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setSnareFlow(value)
        break
      case 3:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setKickFlow(value)
        break
      case 4:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setBassFlow(value)
        break
      case 5:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setMelodyFlow(value)
        break
      case 6:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setHarmonyFlow(value)
        break
      case 8:
        var value = new proto.beatgen.InstrumentFlow()
        reader.readMessage(value, proto.beatgen.InstrumentFlow.deserializeBinaryFromReader)
        msg.setSpecialFlow(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.SongStructure.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.SongStructure.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.SongStructure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.SongStructure.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getHatFlow()
  if (f !== null) {
    writer.writeMessage(1, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getPercFlow()
  if (f !== null) {
    writer.writeMessage(7, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getSnareFlow()
  if (f !== null) {
    writer.writeMessage(2, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getKickFlow()
  if (f !== null) {
    writer.writeMessage(3, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getBassFlow()
  if (f !== null) {
    writer.writeMessage(4, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getMelodyFlow()
  if (f !== null) {
    writer.writeMessage(5, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getHarmonyFlow()
  if (f !== null) {
    writer.writeMessage(6, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
  f = message.getSpecialFlow()
  if (f !== null) {
    writer.writeMessage(8, f, proto.beatgen.InstrumentFlow.serializeBinaryToWriter)
  }
}

/**
 * optional InstrumentFlow hat_flow = 1;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getHatFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 1)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setHatFlow = function (value) {
  jspb.Message.setWrapperField(this, 1, value)
}

proto.beatgen.SongStructure.prototype.clearHatFlow = function () {
  this.setHatFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasHatFlow = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional InstrumentFlow perc_flow = 7;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getPercFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 7)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setPercFlow = function (value) {
  jspb.Message.setWrapperField(this, 7, value)
}

proto.beatgen.SongStructure.prototype.clearPercFlow = function () {
  this.setPercFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasPercFlow = function () {
  return jspb.Message.getField(this, 7) !== null
}

/**
 * optional InstrumentFlow snare_flow = 2;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getSnareFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 2)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setSnareFlow = function (value) {
  jspb.Message.setWrapperField(this, 2, value)
}

proto.beatgen.SongStructure.prototype.clearSnareFlow = function () {
  this.setSnareFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasSnareFlow = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * optional InstrumentFlow kick_flow = 3;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getKickFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 3)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setKickFlow = function (value) {
  jspb.Message.setWrapperField(this, 3, value)
}

proto.beatgen.SongStructure.prototype.clearKickFlow = function () {
  this.setKickFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasKickFlow = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * optional InstrumentFlow bass_flow = 4;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getBassFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 4)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setBassFlow = function (value) {
  jspb.Message.setWrapperField(this, 4, value)
}

proto.beatgen.SongStructure.prototype.clearBassFlow = function () {
  this.setBassFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasBassFlow = function () {
  return jspb.Message.getField(this, 4) !== null
}

/**
 * optional InstrumentFlow melody_flow = 5;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getMelodyFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 5)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setMelodyFlow = function (value) {
  jspb.Message.setWrapperField(this, 5, value)
}

proto.beatgen.SongStructure.prototype.clearMelodyFlow = function () {
  this.setMelodyFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasMelodyFlow = function () {
  return jspb.Message.getField(this, 5) !== null
}

/**
 * optional InstrumentFlow harmony_flow = 6;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getHarmonyFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 6)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setHarmonyFlow = function (value) {
  jspb.Message.setWrapperField(this, 6, value)
}

proto.beatgen.SongStructure.prototype.clearHarmonyFlow = function () {
  this.setHarmonyFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasHarmonyFlow = function () {
  return jspb.Message.getField(this, 6) !== null
}

/**
 * optional InstrumentFlow special_flow = 8;
 * @return {?proto.beatgen.InstrumentFlow}
 */
proto.beatgen.SongStructure.prototype.getSpecialFlow = function () {
  return /** @type{?proto.beatgen.InstrumentFlow} */ (
    jspb.Message.getWrapperField(this, proto.beatgen.InstrumentFlow, 8)
  )
}

/** @param {?proto.beatgen.InstrumentFlow|undefined} value */
proto.beatgen.SongStructure.prototype.setSpecialFlow = function (value) {
  jspb.Message.setWrapperField(this, 8, value)
}

proto.beatgen.SongStructure.prototype.clearSpecialFlow = function () {
  this.setSpecialFlow(undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SongStructure.prototype.hasSpecialFlow = function () {
  return jspb.Message.getField(this, 8) !== null
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.InstrumentFlow = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.beatgen.InstrumentFlow.repeatedFields_, null)
}
goog.inherits(proto.beatgen.InstrumentFlow, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.InstrumentFlow.displayName = 'proto.beatgen.InstrumentFlow'
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.beatgen.InstrumentFlow.repeatedFields_ = [1]

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.InstrumentFlow.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.InstrumentFlow.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.InstrumentFlow} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.InstrumentFlow.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        flowList: jspb.Message.getRepeatedField(msg, 1)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.InstrumentFlow}
 */
proto.beatgen.InstrumentFlow.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.InstrumentFlow()
  return proto.beatgen.InstrumentFlow.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.InstrumentFlow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.InstrumentFlow}
 */
proto.beatgen.InstrumentFlow.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {!proto.beatgen.InstrumentFlow.Part} */ (reader.readEnum())
        msg.addFlow(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.InstrumentFlow.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.InstrumentFlow.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.InstrumentFlow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.InstrumentFlow.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getFlowList()
  if (f.length > 0) {
    writer.writeRepeatedEnum(1, f)
  }
}

/**
 * @enum {number}
 */
proto.beatgen.InstrumentFlow.Part = {
  UNKNOWN: 0,
  SILENT: 1,
  A: 2,
  B: 3,
  C: 4
}

/**
 * repeated Part flow = 1;
 * @return {!Array.<!proto.beatgen.InstrumentFlow.Part>}
 */
proto.beatgen.InstrumentFlow.prototype.getFlowList = function () {
  return /** @type {!Array.<!proto.beatgen.InstrumentFlow.Part>} */ (
    jspb.Message.getRepeatedField(this, 1)
  )
}

/** @param {!Array.<!proto.beatgen.InstrumentFlow.Part>} value */
proto.beatgen.InstrumentFlow.prototype.setFlowList = function (value) {
  jspb.Message.setField(this, 1, value || [])
}

/**
 * @param {!proto.beatgen.InstrumentFlow.Part} value
 * @param {number=} opt_index
 */
proto.beatgen.InstrumentFlow.prototype.addFlow = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index)
}

proto.beatgen.InstrumentFlow.prototype.clearFlowList = function () {
  this.setFlowList([])
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.InstrumentGain = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.InstrumentGain, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.InstrumentGain.displayName = 'proto.beatgen.InstrumentGain'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.InstrumentGain.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.InstrumentGain.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.InstrumentGain} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.InstrumentGain.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        bass: jspb.Message.getField(msg, 1),
        melody: jspb.Message.getField(msg, 2),
        harmony: jspb.Message.getField(msg, 3),
        kick: jspb.Message.getField(msg, 4),
        snare: jspb.Message.getField(msg, 5),
        hat: jspb.Message.getField(msg, 6),
        perc: jspb.Message.getField(msg, 7),
        special: jspb.Message.getField(msg, 8)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.InstrumentGain}
 */
proto.beatgen.InstrumentGain.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.InstrumentGain()
  return proto.beatgen.InstrumentGain.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.InstrumentGain} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.InstrumentGain}
 */
proto.beatgen.InstrumentGain.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setBass(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMelody(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setHarmony(value)
        break
      case 4:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setKick(value)
        break
      case 5:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSnare(value)
        break
      case 6:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setHat(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setPerc(value)
        break
      case 8:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSpecial(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.InstrumentGain.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.InstrumentGain.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.InstrumentGain} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.InstrumentGain.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = /** @type {number} */ (jspb.Message.getField(message, 1))
  if (f !== null) {
    writer.writeInt32(1, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2))
  if (f !== null) {
    writer.writeInt32(2, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3))
  if (f !== null) {
    writer.writeInt32(3, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4))
  if (f !== null) {
    writer.writeInt32(4, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5))
  if (f !== null) {
    writer.writeInt32(5, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6))
  if (f !== null) {
    writer.writeInt32(6, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7))
  if (f !== null) {
    writer.writeInt32(7, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8))
  if (f !== null) {
    writer.writeInt32(8, f)
  }
}

/**
 * optional int32 bass = 1;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getBass = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setBass = function (value) {
  jspb.Message.setField(this, 1, value)
}

proto.beatgen.InstrumentGain.prototype.clearBass = function () {
  jspb.Message.setField(this, 1, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasBass = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional int32 melody = 2;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getMelody = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setMelody = function (value) {
  jspb.Message.setField(this, 2, value)
}

proto.beatgen.InstrumentGain.prototype.clearMelody = function () {
  jspb.Message.setField(this, 2, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasMelody = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * optional int32 harmony = 3;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getHarmony = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setHarmony = function (value) {
  jspb.Message.setField(this, 3, value)
}

proto.beatgen.InstrumentGain.prototype.clearHarmony = function () {
  jspb.Message.setField(this, 3, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasHarmony = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * optional int32 kick = 4;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getKick = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setKick = function (value) {
  jspb.Message.setField(this, 4, value)
}

proto.beatgen.InstrumentGain.prototype.clearKick = function () {
  jspb.Message.setField(this, 4, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasKick = function () {
  return jspb.Message.getField(this, 4) !== null
}

/**
 * optional int32 snare = 5;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getSnare = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setSnare = function (value) {
  jspb.Message.setField(this, 5, value)
}

proto.beatgen.InstrumentGain.prototype.clearSnare = function () {
  jspb.Message.setField(this, 5, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasSnare = function () {
  return jspb.Message.getField(this, 5) !== null
}

/**
 * optional int32 hat = 6;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getHat = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setHat = function (value) {
  jspb.Message.setField(this, 6, value)
}

proto.beatgen.InstrumentGain.prototype.clearHat = function () {
  jspb.Message.setField(this, 6, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasHat = function () {
  return jspb.Message.getField(this, 6) !== null
}

/**
 * optional int32 perc = 7;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getPerc = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setPerc = function (value) {
  jspb.Message.setField(this, 7, value)
}

proto.beatgen.InstrumentGain.prototype.clearPerc = function () {
  jspb.Message.setField(this, 7, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasPerc = function () {
  return jspb.Message.getField(this, 7) !== null
}

/**
 * optional int32 special = 8;
 * @return {number}
 */
proto.beatgen.InstrumentGain.prototype.getSpecial = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0))
}

/** @param {number} value */
proto.beatgen.InstrumentGain.prototype.setSpecial = function (value) {
  jspb.Message.setField(this, 8, value)
}

proto.beatgen.InstrumentGain.prototype.clearSpecial = function () {
  jspb.Message.setField(this, 8, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.InstrumentGain.prototype.hasSpecial = function () {
  return jspb.Message.getField(this, 8) !== null
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.MasterCompressor = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.MasterCompressor, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.MasterCompressor.displayName = 'proto.beatgen.MasterCompressor'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.MasterCompressor.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.MasterCompressor.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.MasterCompressor} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.MasterCompressor.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        threshold: jspb.Message.getField(msg, 1),
        ratio: jspb.Message.getField(msg, 2),
        knee: jspb.Message.getField(msg, 3)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.MasterCompressor}
 */
proto.beatgen.MasterCompressor.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.MasterCompressor()
  return proto.beatgen.MasterCompressor.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.MasterCompressor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.MasterCompressor}
 */
proto.beatgen.MasterCompressor.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setThreshold(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setRatio(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setKnee(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.MasterCompressor.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.MasterCompressor.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.MasterCompressor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.MasterCompressor.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = /** @type {number} */ (jspb.Message.getField(message, 1))
  if (f !== null) {
    writer.writeInt32(1, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2))
  if (f !== null) {
    writer.writeInt32(2, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3))
  if (f !== null) {
    writer.writeInt32(3, f)
  }
}

/**
 * optional int32 threshold = 1;
 * @return {number}
 */
proto.beatgen.MasterCompressor.prototype.getThreshold = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/** @param {number} value */
proto.beatgen.MasterCompressor.prototype.setThreshold = function (value) {
  jspb.Message.setField(this, 1, value)
}

proto.beatgen.MasterCompressor.prototype.clearThreshold = function () {
  jspb.Message.setField(this, 1, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.MasterCompressor.prototype.hasThreshold = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional int32 ratio = 2;
 * @return {number}
 */
proto.beatgen.MasterCompressor.prototype.getRatio = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/** @param {number} value */
proto.beatgen.MasterCompressor.prototype.setRatio = function (value) {
  jspb.Message.setField(this, 2, value)
}

proto.beatgen.MasterCompressor.prototype.clearRatio = function () {
  jspb.Message.setField(this, 2, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.MasterCompressor.prototype.hasRatio = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * optional int32 knee = 3;
 * @return {number}
 */
proto.beatgen.MasterCompressor.prototype.getKnee = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/** @param {number} value */
proto.beatgen.MasterCompressor.prototype.setKnee = function (value) {
  jspb.Message.setField(this, 3, value)
}

proto.beatgen.MasterCompressor.prototype.clearKnee = function () {
  jspb.Message.setField(this, 3, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.MasterCompressor.prototype.hasKnee = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.Equalizer = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.Equalizer, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.Equalizer.displayName = 'proto.beatgen.Equalizer'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.Equalizer.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.Equalizer.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.Equalizer} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.Equalizer.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        low: jspb.Message.getField(msg, 1),
        mid: jspb.Message.getField(msg, 2),
        high: jspb.Message.getField(msg, 3)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.Equalizer}
 */
proto.beatgen.Equalizer.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.Equalizer()
  return proto.beatgen.Equalizer.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.Equalizer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.Equalizer}
 */
proto.beatgen.Equalizer.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setLow(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMid(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setHigh(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.Equalizer.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.Equalizer.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.Equalizer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.Equalizer.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = /** @type {number} */ (jspb.Message.getField(message, 1))
  if (f !== null) {
    writer.writeInt32(1, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2))
  if (f !== null) {
    writer.writeInt32(2, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3))
  if (f !== null) {
    writer.writeInt32(3, f)
  }
}

/**
 * optional int32 low = 1;
 * @return {number}
 */
proto.beatgen.Equalizer.prototype.getLow = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/** @param {number} value */
proto.beatgen.Equalizer.prototype.setLow = function (value) {
  jspb.Message.setField(this, 1, value)
}

proto.beatgen.Equalizer.prototype.clearLow = function () {
  jspb.Message.setField(this, 1, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Equalizer.prototype.hasLow = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional int32 mid = 2;
 * @return {number}
 */
proto.beatgen.Equalizer.prototype.getMid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/** @param {number} value */
proto.beatgen.Equalizer.prototype.setMid = function (value) {
  jspb.Message.setField(this, 2, value)
}

proto.beatgen.Equalizer.prototype.clearMid = function () {
  jspb.Message.setField(this, 2, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Equalizer.prototype.hasMid = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * optional int32 high = 3;
 * @return {number}
 */
proto.beatgen.Equalizer.prototype.getHigh = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/** @param {number} value */
proto.beatgen.Equalizer.prototype.setHigh = function (value) {
  jspb.Message.setField(this, 3, value)
}

proto.beatgen.Equalizer.prototype.clearHigh = function () {
  jspb.Message.setField(this, 3, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Equalizer.prototype.hasHigh = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.SelectedSamples = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.SelectedSamples, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.SelectedSamples.displayName = 'proto.beatgen.SelectedSamples'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.SelectedSamples.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.SelectedSamples.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.SelectedSamples} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.SelectedSamples.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        hat: jspb.Message.getField(msg, 1),
        perc: jspb.Message.getField(msg, 3),
        snare: jspb.Message.getField(msg, 4),
        kick: jspb.Message.getField(msg, 6),
        bass: jspb.Message.getField(msg, 7),
        melody: jspb.Message.getField(msg, 8),
        harmony: jspb.Message.getField(msg, 9),
        special: jspb.Message.getField(msg, 11),
        hiHatAlt: jspb.Message.getField(msg, 2),
        clap: jspb.Message.getField(msg, 5),
        chant: jspb.Message.getField(msg, 10)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.SelectedSamples}
 */
proto.beatgen.SelectedSamples.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.SelectedSamples()
  return proto.beatgen.SelectedSamples.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.SelectedSamples} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.SelectedSamples}
 */
proto.beatgen.SelectedSamples.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setHat(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setPerc(value)
        break
      case 4:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSnare(value)
        break
      case 6:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setKick(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setBass(value)
        break
      case 8:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMelody(value)
        break
      case 9:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setHarmony(value)
        break
      case 11:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSpecial(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setHiHatAlt(value)
        break
      case 5:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setClap(value)
        break
      case 10:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setChant(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.SelectedSamples.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.SelectedSamples.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.SelectedSamples} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.SelectedSamples.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = /** @type {number} */ (jspb.Message.getField(message, 1))
  if (f !== null) {
    writer.writeInt32(1, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3))
  if (f !== null) {
    writer.writeInt32(3, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4))
  if (f !== null) {
    writer.writeInt32(4, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6))
  if (f !== null) {
    writer.writeInt32(6, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7))
  if (f !== null) {
    writer.writeInt32(7, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8))
  if (f !== null) {
    writer.writeInt32(8, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9))
  if (f !== null) {
    writer.writeInt32(9, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11))
  if (f !== null) {
    writer.writeInt32(11, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2))
  if (f !== null) {
    writer.writeInt32(2, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5))
  if (f !== null) {
    writer.writeInt32(5, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10))
  if (f !== null) {
    writer.writeInt32(10, f)
  }
}

/**
 * optional int32 hat = 1;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getHat = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setHat = function (value) {
  jspb.Message.setField(this, 1, value)
}

proto.beatgen.SelectedSamples.prototype.clearHat = function () {
  jspb.Message.setField(this, 1, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasHat = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional int32 perc = 3;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getPerc = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setPerc = function (value) {
  jspb.Message.setField(this, 3, value)
}

proto.beatgen.SelectedSamples.prototype.clearPerc = function () {
  jspb.Message.setField(this, 3, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasPerc = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * optional int32 snare = 4;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getSnare = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setSnare = function (value) {
  jspb.Message.setField(this, 4, value)
}

proto.beatgen.SelectedSamples.prototype.clearSnare = function () {
  jspb.Message.setField(this, 4, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasSnare = function () {
  return jspb.Message.getField(this, 4) !== null
}

/**
 * optional int32 kick = 6;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getKick = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setKick = function (value) {
  jspb.Message.setField(this, 6, value)
}

proto.beatgen.SelectedSamples.prototype.clearKick = function () {
  jspb.Message.setField(this, 6, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasKick = function () {
  return jspb.Message.getField(this, 6) !== null
}

/**
 * optional int32 bass = 7;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getBass = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setBass = function (value) {
  jspb.Message.setField(this, 7, value)
}

proto.beatgen.SelectedSamples.prototype.clearBass = function () {
  jspb.Message.setField(this, 7, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasBass = function () {
  return jspb.Message.getField(this, 7) !== null
}

/**
 * optional int32 melody = 8;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getMelody = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setMelody = function (value) {
  jspb.Message.setField(this, 8, value)
}

proto.beatgen.SelectedSamples.prototype.clearMelody = function () {
  jspb.Message.setField(this, 8, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasMelody = function () {
  return jspb.Message.getField(this, 8) !== null
}

/**
 * optional int32 harmony = 9;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getHarmony = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setHarmony = function (value) {
  jspb.Message.setField(this, 9, value)
}

proto.beatgen.SelectedSamples.prototype.clearHarmony = function () {
  jspb.Message.setField(this, 9, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasHarmony = function () {
  return jspb.Message.getField(this, 9) !== null
}

/**
 * optional int32 special = 11;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getSpecial = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setSpecial = function (value) {
  jspb.Message.setField(this, 11, value)
}

proto.beatgen.SelectedSamples.prototype.clearSpecial = function () {
  jspb.Message.setField(this, 11, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasSpecial = function () {
  return jspb.Message.getField(this, 11) !== null
}

/**
 * optional int32 hi_hat_alt = 2;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getHiHatAlt = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setHiHatAlt = function (value) {
  jspb.Message.setField(this, 2, value)
}

proto.beatgen.SelectedSamples.prototype.clearHiHatAlt = function () {
  jspb.Message.setField(this, 2, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasHiHatAlt = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * optional int32 clap = 5;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getClap = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setClap = function (value) {
  jspb.Message.setField(this, 5, value)
}

proto.beatgen.SelectedSamples.prototype.clearClap = function () {
  jspb.Message.setField(this, 5, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasClap = function () {
  return jspb.Message.getField(this, 5) !== null
}

/**
 * optional int32 chant = 10;
 * @return {number}
 */
proto.beatgen.SelectedSamples.prototype.getChant = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0))
}

/** @param {number} value */
proto.beatgen.SelectedSamples.prototype.setChant = function (value) {
  jspb.Message.setField(this, 10, value)
}

proto.beatgen.SelectedSamples.prototype.clearChant = function () {
  jspb.Message.setField(this, 10, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.SelectedSamples.prototype.hasChant = function () {
  return jspb.Message.getField(this, 10) !== null
}

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.beatgen.Sound = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.beatgen.Sound, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  proto.beatgen.Sound.displayName = 'proto.beatgen.Sound'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.beatgen.Sound.prototype.toObject = function (opt_includeInstance) {
    return proto.beatgen.Sound.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.beatgen.Sound} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.beatgen.Sound.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        type: jspb.Message.getField(msg, 1),
        semitones: jspb.Message.getField(msg, 2),
        gain: jspb.Message.getField(msg, 3),
        time: jspb.Message.getField(msg, 4),
        cutoff: jspb.Message.getField(msg, 5)
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.beatgen.Sound}
 */
proto.beatgen.Sound.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.beatgen.Sound()
  return proto.beatgen.Sound.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.beatgen.Sound} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.beatgen.Sound}
 */
proto.beatgen.Sound.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {!proto.beatgen.SampleType} */ (reader.readEnum())
        msg.setType(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSemitones(value)
        break
      case 3:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setGain(value)
        break
      case 4:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setTime(value)
        break
      case 5:
        var value = /** @type {boolean} */ (reader.readBool())
        msg.setCutoff(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.beatgen.Sound.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.beatgen.Sound.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.beatgen.Sound} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.beatgen.Sound.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = /** @type {!proto.beatgen.SampleType} */ (jspb.Message.getField(message, 1))
  if (f !== null) {
    writer.writeEnum(1, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2))
  if (f !== null) {
    writer.writeInt32(2, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3))
  if (f !== null) {
    writer.writeInt32(3, f)
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4))
  if (f !== null) {
    writer.writeInt32(4, f)
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5))
  if (f !== null) {
    writer.writeBool(5, f)
  }
}

/**
 * optional SampleType type = 1;
 * @return {!proto.beatgen.SampleType}
 */
proto.beatgen.Sound.prototype.getType = function () {
  return /** @type {!proto.beatgen.SampleType} */ (jspb.Message.getFieldWithDefault(this, 1, 1))
}

/** @param {!proto.beatgen.SampleType} value */
proto.beatgen.Sound.prototype.setType = function (value) {
  jspb.Message.setField(this, 1, value)
}

proto.beatgen.Sound.prototype.clearType = function () {
  jspb.Message.setField(this, 1, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Sound.prototype.hasType = function () {
  return jspb.Message.getField(this, 1) !== null
}

/**
 * optional int32 semitones = 2;
 * @return {number}
 */
proto.beatgen.Sound.prototype.getSemitones = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/** @param {number} value */
proto.beatgen.Sound.prototype.setSemitones = function (value) {
  jspb.Message.setField(this, 2, value)
}

proto.beatgen.Sound.prototype.clearSemitones = function () {
  jspb.Message.setField(this, 2, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Sound.prototype.hasSemitones = function () {
  return jspb.Message.getField(this, 2) !== null
}

/**
 * optional int32 gain = 3;
 * @return {number}
 */
proto.beatgen.Sound.prototype.getGain = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0))
}

/** @param {number} value */
proto.beatgen.Sound.prototype.setGain = function (value) {
  jspb.Message.setField(this, 3, value)
}

proto.beatgen.Sound.prototype.clearGain = function () {
  jspb.Message.setField(this, 3, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Sound.prototype.hasGain = function () {
  return jspb.Message.getField(this, 3) !== null
}

/**
 * optional int32 time = 4;
 * @return {number}
 */
proto.beatgen.Sound.prototype.getTime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/** @param {number} value */
proto.beatgen.Sound.prototype.setTime = function (value) {
  jspb.Message.setField(this, 4, value)
}

proto.beatgen.Sound.prototype.clearTime = function () {
  jspb.Message.setField(this, 4, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Sound.prototype.hasTime = function () {
  return jspb.Message.getField(this, 4) !== null
}

/**
 * optional bool cutoff = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.beatgen.Sound.prototype.getCutoff = function () {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false))
}

/** @param {boolean} value */
proto.beatgen.Sound.prototype.setCutoff = function (value) {
  jspb.Message.setField(this, 5, value)
}

proto.beatgen.Sound.prototype.clearCutoff = function () {
  jspb.Message.setField(this, 5, undefined)
}

/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.beatgen.Sound.prototype.hasCutoff = function () {
  return jspb.Message.getField(this, 5) !== null
}

/**
 * @enum {number}
 */
proto.beatgen.Octave = {
  ZERO: 0,
  PLUS_ONE: 1,
  MINUS_ONE: 2
}

/**
 * @enum {number}
 */
proto.beatgen.Key = {
  C_MINOR: 0,
  C_SHARP_MINOR: 1,
  D_MINOR: 2,
  D_SHARP_MINOR: 3,
  E_MINOR: 4,
  F_MINOR: 5,
  F_SHARP_MINOR: 6,
  G_MINOR: 7,
  G_SHARP_MINOR: 8,
  A_MINOR: 9,
  A_SHARP_MINOR: 10,
  B_MINOR: 11,
  C_MAJOR: 12,
  C_SHARP_MAJOR: 13,
  D_MAJOR: 14,
  D_SHARP_MAJOR: 15,
  E_MAJOR: 16,
  F_MAJOR: 17,
  F_SHARP_MAJOR: 18,
  G_MAJOR: 19,
  G_SHARP_MAJOR: 20,
  A_MAJOR: 21,
  A_SHARP_MAJOR: 22,
  B_MAJOR: 23
}

/**
 * @enum {number}
 */
proto.beatgen.SampleType = {
  HAT: 1,
  PERC: 3,
  SNARE: 4,
  KICK: 6,
  BASS: 7,
  MELODY: 8,
  HARMONY: 9,
  SPECIAL: 11,
  CLAP: 5,
  HI_HAT_ALT: 2,
  CHANT: 10
}

goog.object.extend(exports, proto.beatgen)
